import { ThemeOptions } from '@mui/material'

export const themeOptions: ThemeOptions = {
    components: {
        MuiTextField: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#008AEE',
                },
            },
            defaultProps: {
                disableElevation: true,
                variant: 'contained',
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: '#113956',
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#113956',
                        borderRight: `5px solid #008AEE`,
                    },
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    fontSize: '55px',
                    fontWeight: '600',
                },
            },
        },
    },
}

// TODO
export const customThemeOptions = {
    warning: '#e8c902',
}
